export class Config {
    API_ENDPOINT = process.env['REACT_APP_API_ENDPOINT'] || 'https://api-snap.seepilot.com';

}

export default new Config;



// WEBPACK FOOTER //
// ./src/config.ts